import New from "csi/table/New";
import declare from "dojo/_base/declare";
import PromoteToTheme from "../PromoteToTheme";
const NewThemeFromStyle = declare([New, PromoteToTheme], {
});
export = NewThemeFromStyle;